import { useEffect, useState } from "react"

export function useDelayLoading(loading: boolean, delay: number = 100) {
  const [delayedLoading, setDelayedLoading] = useState(loading)

  useEffect(() => {
    if (loading) {
      setDelayedLoading(true)
      return
    }

    const timer = setTimeout(() => {
      setDelayedLoading(false)
    }, delay)

    return () => clearTimeout(timer)
  }, [loading, delay])

  return delayedLoading
}
